module.exports = __webpack_public_path__ + "img/2.2a9dc6fb.jpg";